//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import ListagemPage from '../../components/templates/ListagemPage';
import TopoListagem from '../../components/Topo/TopoListagem';
import { objectsConstants } from '../../_constants/objects.constants';
import { tableHelper } from '../../_helpers/tableHelper';
import { estabelecimentoFinanceiroService } from '../../_services/estabelecimentoFinanceiro.service';
import EstabelecimentoFinanceiroListFilter from './EstabelecimentoFinanceiroListFilter';

const columns = [
  {
    path: 'id',
    title: '',
    notExport: true,
    isKey: true,
    hidden: true
  },
  {
    path: 'foto',
    title: '',
    isKey: false,
    isAvatar: true,
    dataSort: false,
    propsMidiaId: 'foto.id',
    className: 'avatar-list',
    width: '100px',
    notExport: true,
  },
  {
    path: 'nome',
    pathFilter: 'nome',
    title: 'Nome do estabelecimentoFinanceiro',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    width: '25%',
  },
  {
    path: 'empresa.nome',
    pathFilter: 'empresa.nome',
    title: 'Empresa',
    isKey: false,
    dataSort: true,
    className: 'column-bold',
    width: '25%',

  },
  {
    path: 'dataProximoPagamento',
    pathFilter: 'dataProximoPagamento',
    title: 'Data Proximo Pagamento',
    isKey: false,
    dataSort: true,
    isDate: true,

  },
  {
    path: 'status.name',
    pathFilter: 'status.name',
    title: 'Status',
    dataSort: true,
    isStatusEnum: true

  },
  {
    path: 'bloqueadoFencom',
    pathFilter: 'bloqueadoFencom',
    title: 'Bloqueio Fencom',
    dataSort: true,
    yesNo: true
  },
];

const endPoint = '/estabelecimentoFinanceiro/novo';
const endPointView = '/estabelecimentoFinanceiro/view/';
class EstabelecimentoFinanceiroListage extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);
    let fields = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.path;
      }
    );
    let labels = _.map(
      _.filter(columns, function (coluna) {
        return !coluna.notExport;
      }),
      function (coluna) {
        return coluna.title;
      }
    );
    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    this.props.history.push(endPointView + row.id);
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
    // this.props.history.push({
    //   pathname: endPoint,
    //   state: {
    //     titlePage: 'Colaboradores',
    //   },
    // });
  };


  render() {
    const tableColumn = _.map(columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle={objectsConstants.TITULO_PAGINA_ESTABELECIMENTO}
          subTitle=" "
          canBack={false}
        />

        <TopoListagem
          securityActionDo={objectsConstants.VIEW}
          securityActionOn={objectsConstants.CRUD_ESTABELECIMENTOS_EDITAR}
          buttonActionClassName={'btn-light'}
          buttonAction={() => {
            this.handleNewButton();
          }}
          securityActionIcon={'icon-btn-add'}
          securityActionName={'Novoestabelecimento'}
        ></TopoListagem>
        <ListagemPage
          title={`Estabelecimentos Financeiros`}
          showNewButton={false}
          delete={() => { }}
          service={estabelecimentoFinanceiroService}
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={EstabelecimentoFinanceiroListFilter}
          fields={this.state.fields}
          controller="api/estabelecimento"
          labels={this.state.labels}
          columns={columns}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(EstabelecimentoFinanceiroListage);
